import React from 'react';
import * as R from 'ramda';
import { appCopy } from '../../helpers/appCopy';

export function text(params, ...rest) {
  const path = R.split('.')(params);
  const str = R.path(path)(appCopy) || '';
  const values = [...rest];
  if (values && values.map) {
    return values.reduce((acc, val, i) => acc.replace(`$_${i + 1}`, val), str);
  }
  return str;
}
function Text({ bundle }) {
  const t = text(bundle);
  return <>{t}</>;
}
export default Text;
